import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { EventService } from 'src/app/Services/Event/event.service';
import { CommentaireService } from 'src/app/Services/Commentaire/commentaire.service';
import { faHeart, faTrash, faComment, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { UserService } from 'src/app/Services/User/user.service';
import { Commentaire } from 'src/app/Models/Commentaire';
import { ParticipantService } from 'src/app/Services/Participant/participant.service';

import { ToastService } from 'src/app/Services/toast/toast.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {
  id: any;
  idUser = localStorage.getItem("Id");
  commentaire: any;
  eventa: any;
  user: any;
  participant : any ;  
  reponse: any;
  nComment: number;
  faHeart = faHeart;
  faTrash = faTrash;
  faThumbsUp = faThumbsUp;
  faComment = faComment;
  faThumbsDown = faThumbsDown;
  comment: any = {};
  listReponse: any;
  hideCommentform = true;
  participantId: any;
  participationCount: number;
  eventDate: Date;
  formattedDate: string;
  isParticipated = false; // Flag to track participation status
  mapUrl: SafeResourceUrl = '';
  
  placeName: string;

  hamClick: boolean;
  
  constructor(
    private eventservice: EventService,
    private renderer: Renderer2,
    private commentaireservice: CommentaireService,
    private router: Router,
    private userservice: UserService,
    private participantService: ParticipantService,
    private toast: ToastService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.checkParticipation(); // Check participation status on component initialization
    this.getEventById();
    this.getCommentaireByEventId();
    this.CountCommentaireByEventId();
    this.CountParticipantsByEventId();
    this.findUserById(localStorage.getItem("Id"));
    this.hideSupp(this.id);
    this.hideCommentForm();
    const eventDate = new Date(this.eventa.date);
    const formattedDate = this.getFormattedDate(eventDate);
    this.mapUrl = this.generateMapUrl(this.eventa.location);
    console.log('Place Name:', this.placeName);

  
   

  
   
  }
  getFormattedDate(date: Date): string {
    const options = { month: 'short', day: 'numeric' } as Intl.DateTimeFormatOptions;
    return date.toLocaleDateString(undefined, options);
  }
  checkParticipation() {
    this.idUser = localStorage.getItem("Id");
    this.id = localStorage.getItem("IdEvent");
  
    console.log("id user", this.idUser);
    console.log("id event", this.id);
    this.participantService.checkParticipation(this.idUser, this.id).subscribe(
      data => {
        console.log(data); // Check the response data in the console
  
        if (data.isParticipated) {
          // Participant is already enrolled
          console.log("Participant is already enrolled");
          this.isParticipated = true; // Update the value of isParticipated
        } else {
          // Participant is not enrolled
          console.log("Participant is not enrolled");
          this.isParticipated = false; // Update the value of isParticipated
        }
      },
      error => {
        console.error("Error checking participation:", error);
        this.isParticipated = false; // Update the value of isParticipated in case of an error
      }
    );
  }
  
  
  
  
  


  getEventById() {
    this.id = localStorage.getItem('IdEvent');
    console.log(this.id);
    this.eventservice.getEventById(this.id).subscribe(
      data => {
        this.eventa = data;
        console.log(data);
  
        // Generate the mapUrl based on the event's location
        this.mapUrl = this.generateMapUrl(this.eventa.location);
  
        // Extract the place name from the location
        this.placeName = this.extractPlaceName(this.eventa.location);
        console.log('Place Name:', this.placeName);
  
        return this.eventa;
      }
    );
  }
  
  
  
  generateMapUrl(location: string): SafeResourceUrl {
    const apiKey = 'AIzaSyA6Y2BX-uF7ttWvfucY47nRsIUuz_LpJJE'; // Replace 'YOUR_API_KEY' with your actual API key
  
    if (location) {
      const encodedUrl = encodeURIComponent(location);
      const url = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodedUrl}`;
      
      // Extract the place name from the map URL
      const placeName = this.extractPlaceName(location);
      console.log('Place Name:', placeName);
      
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    
    return '';
  }
  
  extractPlaceName(location: string): string {
    if (location) {
      const decodedUrl = decodeURIComponent(location);
      
      // Extract the place name from the decoded URL
      const placeName = decodedUrl.split('/').slice(4, 5).join('/');
      
      return placeName;
    }
    
    return '';
  }
  
  
  
  
  
  

  getCommentaireByEventId() {
    this.id = localStorage.getItem("IdEvent")
    this.commentaireservice.getCommentaireByEventId(this.id).subscribe(
      data => {
        this.commentaire = data;
        return this.commentaire;
      }
    );
  }

  CountCommentaireByEventId() {
    this.id = localStorage.getItem("IdEvent");
    this.commentaireservice.countCommentaireByEventId(this.id).subscribe(
      data => {
        this.nComment = data;
        return this.nComment;
      }
    );
  }

  @ViewChild('like') like: ElementRef;
  likeEvent() {
    const buttonLike = this.like.nativeElement.classList.contains('is-active');
    if(buttonLike) {
      this.renderer.removeClass(this.like.nativeElement, 'is-active');
    } else {
      this.renderer.addClass(this.like.nativeElement, 'is-active');
    }
    this.hamClick = !this.hamClick;
    this.id = localStorage.getItem("IdEvent");
    this.eventservice.likeEvent(this.id).subscribe(
      data => {
        return data;
      }
    );
  }

  dislikeEvent() {
    this.id = localStorage.getItem("IdEvent");
    this.eventservice.disLikeEvent(this.id).subscribe(
      data => {
        return data;
      }
    );
  }

  findUserById(id: any) {
    this.id = localStorage.getItem("Id");
    this.userservice.findById(this.id).subscribe(
      data => {
        this.user = data;
        return this.user;
      }
    );
  }

  addComment(comment: Commentaire) {
    this.id = localStorage.getItem("IdEvent");
    this.idUser = localStorage.getItem("Id");
    this.commentaireservice.addCommentaireEvent(this.id, this.idUser, comment).subscribe(
      data => {
        comment = data;
        console.log(comment)
        return comment;
      }
    );
  }

  deleteCommentaire(id: any) {
    this.commentaireservice.deleteCommentaire(id).subscribe(
      data => {
        return data;
      }
    );
  }

  hideSupp(id: any) {
    if (id == localStorage.getItem("Id")) {
      return false;
    } else {
      return true;
    }
  }

  hideCommentForm() {
    if (localStorage.length > 0) {
      this.hideCommentform = true;
    }
  }

   
  // Participation methods

  /*checkParticipation() {
    const eventId = localStorage.getItem("IdEvent");
    this.participantService.getParticipantsByEventId(eventId).subscribe(
      data => {
        // Check if the current user's ID is present in the list of participants
        const participant = data.find((participant: any) => participant.user === this.idUser);
        if (participant) {
          this.isParticipated = true; // Set the flag to true if participant exists
          this.participantId = participant._id; // Store the participant ID in the component
          localStorage.setItem("ParticipantId", this.participantId); // Store the participantId in localStorage
          localStorage.setItem("isParticipated", "true"); // Set the isParticipated flag to true in localStorage
          console.log("ParticipantId and isParticipated flag stored in localStorage:", this.participantId);
        } else {
          this.isParticipated = false; // Set the flag to false if participant does not exist
          localStorage.removeItem("ParticipantId"); // Remove the participantId from localStorage
          localStorage.setItem("isParticipated", "false"); // Set the isParticipated flag to false in localStorage
          console.log("ParticipantId and isParticipated flag removed from localStorage");
        }
      },
      error => {
        console.error("Error fetching participants:", error);
      }
    );
  }*/
  
  
  
  // Adding to event member
  addParticipant() {
    const eventId = localStorage.getItem("IdEvent");
    this.participantService.createParticipant(this.idUser, eventId).subscribe(
      data => {
        // Participant created successfully
        console.log("Participant created:", data);
  
        if (data.participantId) {
          const participantId = data.participantId; // Get the participant ID from the response
          localStorage.setItem("ParticipantId", participantId); // Store the participantId in localStorage
          console.log("ParticipantId stored in localStorage:", participantId);
  
          this.toast.SuccessToast("Participating in the event with success");
          this.isParticipated = true; // Update the participation status flag
        } else {
          console.log("ParticipantId not found in the response data.");
        }
      },
      error => {
        // Error occurred while creating participant
        console.error("Error creating participant:", error);
        this.toast.ErrorToast('Error creating participant process');
      }
    );
  }
  
  
  cancelParticipation() {
    if (!this.isParticipated) {
      console.log("Participant is already not enrolled");
      return;
    }
  
    const participantId = localStorage.getItem("ParticipantId");
    if (!participantId) {
      console.error("ParticipantId not found in localStorage");
      this.toast.ErrorToast("ParticipantId not found in localStorage");
      return;
    }
  
    this.participantService.cancelParticipant(participantId).subscribe(
      data => {
        // Participation canceled successfully
        console.log("Participation canceled:", data);
        this.toast.SuccessToast('Participation in the event canceled with success!');
  
        this.isParticipated = false; // Update the participation status flag
        localStorage.removeItem("ParticipantId"); // Remove the participantId from localStorage
        console.log("ParticipantId removed from localStorage");
      },
      error => {
        // Error occurred while canceling participation
        console.error("Error canceling participation:", error);
        this.toast.ErrorToast('Error canceling participation');
      }
    );
  }
  
  
  
  
  
  CountParticipantsByEventId() {
    this.id = localStorage.getItem("IdEvent");
    this.participantService.countParticipantsByEventId(this.id).subscribe(
      data => {
        this.participationCount = data.count; // Access the 'count' property of the response object
        console.log(this.participationCount);
      },
      error => {
        console.error("Error counting participations:", error);
      }
    );
  }
  
  
  

}
